export const BUFFERING = 'buffering';
export const PAUSED = 'paused';
